// extracted by mini-css-extract-plugin
export var dateLabel = "_2s-0";
export var dateLabelError = "_2s-1";
export var fullWidth = "_2s-2";
export var smaller = "_2s-3";